import script from "./goRinSyo0020.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0020.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0020.vue?vue&type=style&index=0&id=708f767e&lang=scss"

const __exports__ = script;

export default __exports__